<template>
  <div class="community_list_warpper">
    <div class="swiper_warpper" ref="swiperWarpper">
      <searchHeader></searchHeader>
      <div class="banner_warpper">
        <!-- 发现页的banner -->
        <banner></banner>
        <!-- 公告banner -->
        <noticeBanner></noticeBanner>
      </div>
    </div>
    <communityContentList ref="communityContentListRef"></communityContentList>
  </div>
</template>
<script>
//组件
import banner from '@/components/community/banner.vue' // banner组件
import noticeBanner from '@/components/community/noticeBanner.vue' // banner组件
import communityContentList from '@/components/community/communityContentList/index.vue' // banner组件
import searchHeader from '@/components/community/searchHeader.vue' // banner组件

// 方法
import {
  fomatterNum,
  getCookie,
  isUserEdit,
  isUserLogin,
} from '@/assets/js/common.js'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent'
import { initClassTop, setClassTop } from '@/assets/js/common'

export default {
  name: 'communityList',
  data() {
    return {
      userInfo: {},
      show: false,
      editFlagTip: false,
    }
  },
  components: {
    banner,
    noticeBanner,
    communityContentList,
    searchHeader,
    // shareGuide,
  },
  watch: {
    // currentId: {
    //   immediate: false,//这句重要
    //   deep: true,//深监听
    //   handler (newValue) {
    //     console.log("jianting", newValue)
    //     this.prevClickId = newValue;
    //     this.pageParams.page = 1;
    //   }
    // }
  },
  activated() {
    setClassTop('community_Index')
    this.$store.commit('changeIncludes', ['communityIndex', 'communityList'])
    // 在文章删除后返回列表页，重新获取数据
    if (sessionStorage.getItem('hasDelete')) {
      this.$refs.communityContentListRef.pageParams.page = 1
      this.$refs.communityContentListRef.getArticleList()
      sessionStorage.setItem('hasDelete', false)
    }
    this.shareHome()
  },
  created() {
    // 未登录，不显示提示信息
    this.initPage()
    this.prevClickId = this.currentId
  },
  beforeRouteLeave(to, from, next) {
    initClassTop('community_Index')
    next()
  },
  mounted() {
    BuiedPointClick_Fn('xmhh5CommunityallPageView', {
      xmhh5_Community_Page_Name: '首页',
    })
    console.log('isUserEdit', isUserEdit())
    this.shareHome()
  },
  methods: {
    isUserLogin,
    fomatterNum,
    getCookie,
    // 页面初始化
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    // 获取banner的高度
    getSwiperWarpperHeight() {
      return this.$refs.swiperWarpper.offsetHeight
    },
    // 首页分享初始化
    shareHome() {
      console.warn(location.href.split('#')[0], '当前跳转')
      const shareDataParams = {
        shareLink: this.$http.hostName + '/communityIndex',
        shareDesc: '来社区，跟星妈们一同分享育儿情感',
        shareTitle: '星妈社区',
        imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
      }
      this.wxJsSet.wxShare('fx', shareDataParams, this)
    },
  },
}
</script>
<style lang="less" scoped>
.community_list_warpper {
  width: 100%;
  min-height: 100%;
  // margin-bottom: 60px;
  background: url('../../assets/images/community/indexBg.png') no-repeat top
    left;
  background-size: 100% auto;
  .swiper_warpper {
    padding: 12px 12px 0;
    .banner_warpper {
      border-radius: 6px;
      overflow: hidden;
    }
  }
}
</style>
